<template>
  <div class="sample-dailog dialog">
    <div class="title">
      <h1>上傳數據</h1>
    </div>
    <div class="content container">
      <div class="row">
        <div class="col-12">
          <div class="buttons container">
            <input v-show="false"
              type="file"
              id="import"
              extension="zip,gz,7z,rar"
              multiple="multiple"
              @change="e => fileTypeCheck(e, e => importFileOnChange(e), (e, ea) => addToast('error', '檔案格式有誤，請上傳壓縮檔'))">
            <input type="text" v-show="false" name="import" v-model="dataFiles" v-validate="'required'">
            <div class="mask">
              <label for="import" class="mask" />
              <button class="main-button field-button">
                <span><invisible :size="1" :isFullWidth="true" />選擇數據<invisible :size="1" :isFullWidth="true" /></span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="row" v-if="dataFiles">
        <div class="col-12">
          <table class="table-line">
            <tr>
              <th>
                <center :style="{ width: '100%' }">上傳檔案列表</center>
              </th>
            </tr>
            <tr v-for="(file, index) in dataFiles" :key="index">
              <td>
                <center :style="{ width: '100%' }">
                  <span :class="{ danger: errorFileList.includes(file) }">{{ file.name }}</span>
                </center>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="buttons container">
            <button class="main-button field-button" :class="{ 'loading': onSubmit }" :disabled="disabled" @click="validateUploadData()">
              <span><invisible :size="1" :isFullWidth="true" />上傳<invisible :size="1" :isFullWidth="true" /></span>
            </button>
          </div>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { postUploadDataKit } from '../../api'
import invisible from '../tool/invisible'
import toastMethods from '../../mixins/toastMethods'
import { fileTypeCheck } from '../../constants/global/util.js'

export default {
  components: {
    invisible
  },
  mixins: [
    toastMethods
  ],
  props: {
    param: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      dataFiles: '',
      errorFileList: [],
      onSubmit: false
    }
  },
  computed: {
    disabled () {
      let value = true
      if (this.errors.items.length === 0) {
        value = false
      }
      if (this.onSubmit) {
        value = true
      }
      return value
    },
    // util
    fileTypeCheck: () => fileTypeCheck
  },
  methods: {
    ...mapActions([
      'setUploadingAction'
    ]),
    async importFileOnChange (e) {
      this.dataFiles = Array.from(e.target.files)
      this.errorFileList = []
      e.target.value = ''
    },
    async validateUploadData () {
      this.onSubmit = true
      this.setUploadingAction(true)
      let result = await this.$validator.validateAll()
      if (result) {
        await this.uploadData()
      } else {
        this.addToast('error', '請先選擇數據')
        this.onSubmit = false
        this.setUploadingAction(false)
      }
    },
    async uploadData () {
      try {
        const errorFileList = []
        let config = this.$ls.get('userInfo') || {}
        for (let file of this.dataFiles) {
          try {
            let id = (this.param.datas.find(data => data.sequencing_plate_number + data.sequencing_plate_well_position === file.name.replace(/\..+?$/, '')) || {}).id
            if (id) {
              await postUploadDataKit(id, file, config)
            } else {
              throw new Error()
            }
          } catch (error) {
            errorFileList.push(file)
          }
        }
        if (!errorFileList.length) {
          this.addToast('success', '上傳成功')
          this.$emit('changeModal', {}, true)
        } else {
          this.errorFileList = errorFileList
          this.addToast('error', '部分檔案找不到對應編號，請重新確認')
        }
        this.onSubmit = false
        this.setUploadingAction(false)
      } catch (error) {
        this.addToast('error', !error.response ? error.message : error.response.data.errors[0])
        this.onSubmit = false
        this.setUploadingAction(false)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialog/upload.vue